import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { ClickGallery, CloudConnection } from 'elements-sdk'
import { APIService } from 'api'
import { ModalComponent } from 'common/util.modals'
import { TranslateDirective } from 'common/locale/directives/translate.directive'
import { ClickBlockingDirective } from 'common/util/directives/clickBlocking.directive'

interface Params {
  readonly name: string
  readonly connection: CloudConnection
}

@Component({
  selector: 'create-click-gallery-modal',
  templateUrl: './createClickGalleryModal.component.html',
  imports: [
    FormsModule,
    TranslateDirective,
    ClickBlockingDirective,
  ],
})
export class CreateClickGalleryModalComponent extends ModalComponent<Params, ClickGallery> {
  name: string
  description = ''

  constructor (
    private api: APIService,
  ) {
    super()
    this.name = this.params.name
  }

  readonly create = async () => {
    const gallery = await this.api.click.createClickGallery({
      connectionId: this.params.connection.id.toString(),
      clickGalleryUpdate: {
        name: this.name,
        description: this.description,
      },
    })
    this.complete(gallery)
  }
}
